import { createBrowserHistory } from 'history';
import { setPreviousLocation } from '../common/auth/actions';

import store from '../store';

const _history = createBrowserHistory();

function addLocationQuery(history) {
    store.dispatch({
        type: setPreviousLocation.type,
        payload: history.location.pathname,
    });
}

addLocationQuery(_history);

_history.listen(() => {
    addLocationQuery(_history);
});

export default _history;
